import { EmptyState } from '@orbind/ui'
import { useParams } from 'react-router'
import { PluginFrame } from '../features/plugin/PluginFrame.tsx'

/**
 * A tela inteira de um plugin (SPEC-20260926-2036-plugin-tela-no-rail).
 *
 * Vive sob `/plugins/` e nunca fora: um plugin não pode ocupar rota que
 * colida com módulo nativo, nem hoje nem quando alguém criar um módulo novo.
 *
 * A página é só a moldura. Quem sabe se a extensão existe, se a instalação
 * está viva e se o plugin respondeu é o `PluginFrame`.
 */
export function PluginScreenPage() {
  const { key, ext } = useParams()

  if (!key || !ext) {
    return (
      <EmptyState
        icon="fas fa-plug"
        title="Plugin não encontrado"
        description="O endereço não aponta para nenhuma tela de plugin."
      />
    )
  }

  return <PluginFrame tipo="rail-screen" chave={ext} encaixe="tela" />
}
